export default __webpack_public_path__ + "static/media/wallet2.1586049f.svg";